<template>
    <div class="header--wrapper">
        <div class="logo">
            <div class="logo trinity"><img :src="`${publicPath}logos/trinity.svg`"/></div>
        </div>
        <div class="image" ref="image">
            <img v-if="isMobile()" :src="`${publicPath}headers/trinity_mobile.jpg`"/>
            <img v-else :src="`${publicPath}headers/trinity_desktop.jpg`"/>
        </div>
        <div class="overlay" ref="overlay">
            <Overlay/>
        </div>
  </div>
</template>

<script>
import Overlay from "@/assets/headers/trinity-vod.svg";

export default {
  name: "TrinityHeader",
  components: {
      Overlay
  },
  data () {
    return {
        publicPath: process.env.BASE_URL,
        isMounted: false
    }
  },
  mounted() {
    this.isMounted = true;
    let c = this;
    setTimeout(() => {
        c.positionOverlay();
        c.$refs.overlay.style.opacity = 1;
    }, 300);
    
  },
  methods: {
      isMobile() {
          return screen.width <= 768;
      },
      positionOverlay() {
          if (this.isMounted) {
              let imageBottom = this.$refs.image.offsetHeight;
              let overlayBottom = this.$refs.overlay.offsetTop + this.$refs.overlay.offsetHeight;
              let delta = overlayBottom - imageBottom - (screen.width < 480 ? 0 : 120);
              this.$refs.overlay.style.top = this.$refs.overlay.offsetTop - delta + 'px';
          }
          
      }
  },
  created() {
    window.addEventListener("resize", this.positionOverlay);
  },
  destroyed() {
    window.removeEventListener("resize", this.positionOverlay);
  },


};
</script>

<style scoped lang="scss">
.header--wrapper {
    width: 100%;
    background-color: $color-background-primary;
    display: flex;
    .logo {
        position: absolute;
        left: 20px;
        top: 20px;
        width: 250px;
        img {
            width: 100%;
        }
    }
    .image, img {
        width: 100%;
    }
    .overlay {
        position: absolute;
        right: 0;
        width: 50%;
        opacity: 0;
        transition: all 0.3s ease-in;
        svg {
            width: 100%;
        }
    }


}

</style>